import axios from 'axios';
import { functionExist } from 'cgil-html-utils';
import { DEFAULT_BASE_SERVER_URL, getLog } from '../config';
import { getLocalJwtTokenAuth } from './Login';

const log = getLog('Group', 4, 1);

let instance = null;


/*  Singleton to retrieve objet
 */
class Group {
  constructor() {
    if (!instance) {
      instance = this;
    }
    // to test whether we have singleton or not and store how old is data
    this.time = new Date();
    this.data = [];
    this.isReady = false;
    return instance;
  }

  getErrorMessage(method, msg, err) {
    let errMessage = msg;
    log.e(errMessage);
    if (err.response) {
      const errResponse = err.response;
      log.e(' -- The request was made, but the server responded with a status code > 2xx', errResponse, errResponse.data);
      this.lastErrorMsg = ` ${method} : La requete http a recu en retour un code status=${errResponse.status} >200 ! `;
      errMessage += `${this.lastErrorMsg} <br> Message serveur : ${errResponse.data.message}`;
      this.lastError = err.response;
    } else if (err.request) {
      log.e(' -- The request was made, but no response was received from the server', err.request);
      this.lastErrorMsg = ` ${method} : La requete http n'a pas reçu de reponse du serveur ! `;
      errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.request}`;
      this.lastError = err.request;
    } else {
      log.e(' -- Something happened in setting up the request that triggered an Error', err.message);
      this.lastErrorMsg = ` ${method} : La requete http est erronée et n'a pas pu se faire! `;
      errMessage += `${this.lastErrorMsg} <br> Message serveur : ${err.message}`;
      this.lastError = err.message;
    }
    return errMessage;
  }

  getGroupList(callbackLoaded) {
    const method = 'getGroupList';
    log.t(`## IN ${method}`);
    if (this.data.length > 0) {
      if (functionExist(callbackLoaded)) {
        callbackLoaded(this.data, 'SUCCESS');
      }
    }
    axios.defaults.headers.common.Authorization = getLocalJwtTokenAuth();
    axios.get(`${DEFAULT_BASE_SERVER_URL}/api/groups`)
      .then((resp) => {
        this.lastError = null;
        this.lastErrorMsg = null;
        log.t(`## IN ${method} axios get success resp.data :`, resp.data);
        this.data = resp.data;
        this.isReady = true;
        if (functionExist(callbackLoaded)) {
          callbackLoaded(resp.data, 'SUCCESS');
        }
      })
      .catch((err) => {
        this.isReady = false;
        const errMessage = this.getErrorMessage(method, `## ERREUR RESEAU DANS ${method} PENDANT UN APPEL DISTANT axios.get`, err);
        if (functionExist(callbackLoaded)) callbackLoaded(null, errMessage);
      });
  }
}
const group = new Group();
export default group;
